import { Link } from "react-router-dom";
import { Instagram, Send } from "lucide-react";

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://instagram.com/issyflash",
    testid: "social-instagram",
    icon: (
      <Instagram size={18} strokeWidth={1.5} />
    ),
  },
  {
    name: "X",
    href: "https://x.com/issyflash",
    testid: "social-x",
    icon: (
      <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2H21l-6.51 7.44L22 22h-6.828l-4.788-6.263L4.8 22H2.042l6.966-7.96L2 2h6.914l4.324 5.719L18.244 2Zm-1.196 18h1.777L7.02 4H5.14L17.048 20Z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://tiktok.com/@issyflash",
    testid: "social-tiktok",
    icon: (
      <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true">
        <path d="M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.973-1.166-1.964-1.283-2.657H12.86v14.712c0 .199 0 .395-.008.59a4.63 4.63 0 0 1-.056.611c-.216 1.293-1.15 2.437-2.5 2.87a4.14 4.14 0 0 1-2.11.16 4.174 4.174 0 0 1-2.19-1.17 4.145 4.145 0 0 1-1.086-1.978 4.126 4.126 0 0 1 .046-2.24 4.187 4.187 0 0 1 1.13-1.97 4.169 4.169 0 0 1 2.146-1.144c.75-.146 1.5-.077 2.201.16v-3.65a7.777 7.777 0 0 0-6.023 1.75 7.734 7.734 0 0 0-2.532 4.297 7.694 7.694 0 0 0 .35 4.635 7.756 7.756 0 0 0 2.9 3.658 7.826 7.826 0 0 0 4.53 1.373c1.72 0 3.4-.573 4.767-1.632a7.752 7.752 0 0 0 2.83-4.284c.19-.808.271-1.638.24-2.467V9.13a10.06 10.06 0 0 0 5.905 1.888V7.373a5.822 5.822 0 0 1-3.079-1.81Z" />
      </svg>
    ),
  },
  {
    name: "Telegram",
    href: "https://t.me/issyflash",
    testid: "social-telegram",
    icon: <Send size={17} strokeWidth={1.5} />,
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-white/5 mt-24 md:mt-40 pt-14 pb-10 px-6"
    >
      <div className="max-w-6xl mx-auto">
        {/* Socials block */}
        <div className="text-center">
          <p className="font-mono-serif text-[10px] tracking-[0.4em] text-white/45">
            CONNECT // @ISSYFLASH
          </p>
          <div className="mt-5 flex items-center justify-center gap-3 md:gap-4 flex-wrap">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.name}
                data-testid={s.testid}
                className="group inline-flex items-center gap-2 md:gap-3 px-4 md:px-5 py-2.5 rounded-full border border-white/10 hover:border-white/30 hover:bg-white/[0.03] transition"
              >
                <span className="text-white/80 group-hover:text-white transition">{s.icon}</span>
                <span className="font-mono-serif text-[10px] tracking-[0.3em] text-white/70 group-hover:text-white transition">
                  {s.name.toUpperCase()}
                </span>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="font-mono-serif text-xs tracking-[0.3em] text-white/70">
            THE SYNDICATE
          </div>
          <div className="flex flex-wrap justify-center gap-6 md:gap-8 font-mono-serif text-[10px] tracking-[0.25em] text-white/50">
            <Link to="/" className="hover:text-white transition">HOME</Link>
            <Link to="/about" className="hover:text-white transition">ABOUT</Link>
            <Link to="/pricing" className="hover:text-white transition">MEMBERSHIP</Link>
            <Link to="/testimonials" className="hover:text-white transition">TESTIMONIALS</Link>
            <Link to="/faq" className="hover:text-white transition">FAQ</Link>
            <Link to="/privacy" className="hover:text-white transition">PRIVACY</Link>
            <Link to="/risk-disclosure" className="hover:text-white transition" data-testid="footer-risk-link">RISK DISCLOSURE</Link>
          </div>
          <div className="font-mono-serif text-[10px] tracking-[0.25em] text-white/40">
            © {new Date().getFullYear()} THE SYNDICATE
          </div>
        </div>
      </div>
    </footer>
  );
}
